import { useDispatch, useSelector } from "react-redux";
import { Dialog, DialogContent } from "@mui/material";
import { closeFreqModal } from "../../Store/Slices/frequencySlice"
import AddFrequency from "./AddFrequency";
import EditFrequency from "./EditFrequency";
import DeleteFrequency from "./DeleteFrequency";



const FrequencyDialog = () => {
    const dispatch = useDispatch();
    const { modalStatus } = useSelector((state) => state.freq);

    let content;
    let deleteView = false;

    const roles = sessionStorage.getItem("roles");

    const handleClose = (event, reason) => {
        if (reason !== 'backdropClick') {
            dispatch(closeFreqModal());
        }
    };

    switch (modalStatus) {
        case "add":
            content = roles?.split(",").includes("PRIV_ES_ADD_FREQUENCY") ? <AddFrequency handleClose={handleClose} /> : null;
            break;
        case "edit":
            content = roles?.split(",")?.includes("PRIV_ES_EDIT_FREQUENCY") ? <EditFrequency handleClose={handleClose} /> : null;
            break;
        case "delete":
            deleteView = true;
            content = roles?.split(",").includes("PRIV_ES_DELETE_FREQUENCY") ? <DeleteFrequency handleClose={handleClose} /> : null;
            break;
        default:
            content = null;
    }

    return (
        <Dialog
            fullWidth={true}
            open={["add", "edit", "delete"].includes(modalStatus)}
            onClose={handleClose}
            aria-labelledby="coupon-dialog-title"
            aria-describedby="coupon-dialog-description"
            
        >
            <DialogContent>{content}</DialogContent>
        </Dialog>
    );
};

export default FrequencyDialog;
